import { render } from "./updateAccount.vue?vue&type=template&id=d4f6a734&scoped=true"
import script from "./updateAccount.vue?vue&type=script&lang=js"
export * from "./updateAccount.vue?vue&type=script&lang=js"

import "./updateAccount.vue?vue&type=style&index=0&id=d4f6a734&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f6a734"]])

export default __exports__